import * as MD from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
//Store
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';

const styles = (theme: Theme) => MD.createStyles({});

interface IPropsFromState {
	i18n: I18N;
}

interface IPropsTheme {
	theme: any;
}

interface IPropsFromDispatch {}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	IPropsTheme &
	IConnectedReduxProps;

interface IState {}

export class DashboardContentComponent extends React.Component<
	AllProps,
	IState
> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {};
	}

	public componentDidMount() {}

	static getDerivedStateFromProps(props: AllProps, state: IState) {
		return state;
	}

	public render(): React.ReactNode {
		//const { classes } = this.props;

		return <MD.Grid container direction="column"></MD.Grid>;
	}
}

const mapStateToProps = ({ i18n }: IApplicationState) => ({
	i18n: i18n.i18n,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export const DashboardContent = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(DashboardContentComponent)));
